import createBrowserHistory from 'history/createBrowserHistory';

let history = null;

export function getHistory() {
    if(history == null) {
        history = createBrowserHistory();
    }
    return history;
}



// WEBPACK FOOTER //
// ./src/service/HistoryService.js